export enum TerminateType {
  ACCIDENT,
  NO_DRIVER,
  INTERNAL_ISSUE,
  OTHER
}
